
export const ConfirmActionMixin = {

    methods: {
        confirmAction(title, description) {
            return new Promise((resolve, reject) => {
                this.$modal.show('dialog', {
                    title: title || 'Sigur doriți să faceți asta?',
                    text: description || '',
                    buttons: [
                        {
                            title: this.texts.cancel,
                            handler: () => {
                                this.$modal.hide('dialog');
                                reject();
                            } // Button click handler
                        },
                        {
                            title: this.texts.confirm, // Button title
                            default: true,             // Will be triggered by default if 'Enter' pressed.
                            class: 'btn btn-success',
                            handler: () => {
                                this.$modal.hide('dialog');
                                resolve();
                            } // Button click handler
                        },
                    ]
                });
            });
        },
    },
};
